//@ts-check

/**
 * @type {import("./types").isFileType}
 */
export default (function (path) {
  if (!path) return false;
  return path.indexOf('.') > -1;
});